// BR-38 — `/access/me` as the Cierres shell left it in the auth state: `undefined` until it is
// known, `null` if it could not be read, or the answer. Read it with `utils/cierrePermisos.js`.
//
// A hook rather than a prop so the dialogs three screens share (the closing detail, the manual
// pipeline, "Nuevo cierre") read the same value without every screen handing it down.
import { useSelector } from "react-redux";

export const useAccesoCierres = () => useSelector((state) => state.auth.cierresAccess);
